export default "__VITE_ASSET__l1i$0EXA__"